import React, { useEffect } from 'react';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import styled from 'styled-components';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import { useWorkPropertyVisible } from '../../../shared/hooks/useApi/useWorkPropertyVisible';
import BlockWithVisible from '../BlockWithVisible';
import { useWorkViewStore } from '../../../shared/store/WorkViewStore';
import { SortDirection, WorkSortOrder } from '../../../shared/enum/EnumRepository';
import { useWorkListStore } from '../../../shared/store/WorkListStore';
import { useUnsavedChanges } from '../../../shared/hooks/useUnsavedChanges';
import BlockWithSortVisible from '../BlockWithSortVisible';
import deleteIcon from '../../../asset/icon/delete.png';
import WorkOverviewEditActions from '../WorkOverviewEditActions';

const ColumnInfoMobile: React.FC = () => {
  const { isEditMode } = useEditMode();
  const { workPropertyVisible, getWorkPropertyVisible } = useWorkPropertyVisible();
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const setActiveWork = useWorkViewStore((s) => s.setActiveWork);
  const sortData = useWorkListStore((s) => s.sortData);
  const setSortData = useWorkListStore((s) => s.setSortData);
  const { requestExitEditMode } = useUnsavedChanges();

  useEffect(() => {
    const getWorkPropertyVisibleWithApi = async () => {
      console.log("getting workPropertyVisible...");
      await getWorkPropertyVisible();
    }
    getWorkPropertyVisibleWithApi();
  }, []);

  if (!workPropertyVisible) return null;

  const handleDirectionChange = (field: WorkSortOrder) => {
    if (isEditMode) {
      requestExitEditMode({ confirmWhenClean: true });
      return;
    }

    // 현재 정렬 필드와 같으면 방향만 변경, 다르면 해당 필드로 정렬하고 ASC로 설정
    if (sortData.sort === field) {
      setSortData({
        sort: field,
        direction: sortData.direction === SortDirection.ASC ? SortDirection.DESC :  SortDirection.ASC
      });
    } else {
      setSortData({ sort: field, direction: SortDirection.ASC });
    }
  };

  const handleDelete = () => {
    setActiveWork(null)
  }

  return (
    <>
      <ColumnInfoComp>
        <InfoContainer $isActive={!!activeWork}>
          <ImageBlock />
          <TitleBlock onClick={() => handleDirectionChange(WorkSortOrder.TITLE)}>
            Title
            <SelectDirection
              $isASC={sortData.sort === WorkSortOrder.TITLE && sortData.direction === SortDirection.ASC}
              $isSortField={sortData.sort === WorkSortOrder.TITLE}
            >
              ▼
            </SelectDirection>
          </TitleBlock>
          <BlockWithVisible
            width={"1.5"}
            isColumn={true}
            value={"Size(unit)"}
          />
          <BlockWithVisible
            width={"1.5"}
            isColumn={true}
            value={"Material"}
          />
          <BlockWithSortVisible
            width={"0.8"}
            isColumn={true}
            field={WorkSortOrder.YEAR}
            value={"Year"}
          />
        </InfoContainer>
        {activeWork &&
          <OverviewBlock>
            <OverviewText>Overview</OverviewText>
            <OverviewActions>
              <WorkOverviewEditActions />
              {!isEditMode && (
                <UniversalIconBtn
                  size="small"
                  border={false}
                  isTransparent
                  backgroundImg={deleteIcon}
                  onClick={handleDelete}
                />
              )}
            </OverviewActions>
          </OverviewBlock>
        }
      </ColumnInfoComp>
    </>
  )
}

const ColumnInfoComp = styled.article`
  width: 100%;
  height: 36px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};

  ${({ theme }) => theme.typography.Body_03_1};
`;

const InfoContainer = styled.article<{ $isActive: boolean }>`
  width: ${({ $isActive }) => $isActive ? '0%' : '100%'};
  opacity: ${({ $isActive }) => $isActive ? 0 : 1};
  overflow-x: hidden;
  height: 32px;
  display: flex;
  transition: all 0.7s ease-in-out;
`;

const ImageBlock = styled.div`
  flex: 0.6;
  min-width: 40px;
  max-width: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-right: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
`;

const TitleBlock = styled.div`
  flex: 2.2;

  display: flex;
  align-items: center;
  padding-left: 6px;

  cursor: pointer;
  user-select: none;
`;

const SelectDirection = styled.span<{ $isSortField: boolean; $isASC: boolean }>`
  margin-left: 4px;
  ${({ theme }) => theme.typography.Footer_02};
  color: ${({ theme, $isSortField }) => $isSortField ? theme.colors.color_Gray_03 : theme.colors.color_Gray_05};
  transform: ${({ $isASC, $isSortField }) => {
    if (!$isSortField) return "scale(0.7)"; // 기본: dim 처리된 ▼
    return $isASC ? "scale(0.7)" : "scaleY(-1) scale(0.7)"; // ASC면 그대로, DESC면 뒤집기
  }};
  transition: transform 0.6s ease-in-out;
`;

const OverviewBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const OverviewText = styled.div`
  display: flex;
`

const OverviewActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export default ColumnInfoMobile;
